export default {
    setPreviouslySelectedDataInChat(state,payload){
        state.previouslySelectedChannelOrUser = payload;
    },
    addChatStartupData(state, payload){
        Object.assign(state.startupData, payload)
    },
    setFirstPanelClickVal(state, payload){
        console.log("state.clickFirstPanel",state.clickFirstPanel)
        state.clickFirstPanel = payload;
    },
    setAIPanelState(state, payload){
        state.AIPanelInfo = payload;
    }
};
